import { verifyMouse } from "../../functionsGlobal";
import * as Styles from "./styles";

export const Modal = ({ children, close , ...rest}) => {
  const handleClickCloseModal = (event, callback) =>{
    if(event.target.id === 'box-lateral-responsive') callback();
  }

  return (
    <Styles.Container
      id="box-lateral-responsive"
      onMouseDown={(e) => verifyMouse(e, handleClickCloseModal, close)}
      onMouseUp={(e) => verifyMouse(e, handleClickCloseModal, close)}
      {...rest}
      animation={rest?.animation ?? true}
    >
      <Styles.WrapperModal {...rest}>{children}</Styles.WrapperModal>
    </Styles.Container>
  );
};